<template>
  <div class="index">
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="200px" style="background-color: #BDA17A;" class="aside-menu">
        <div class="x-index-logo"></div>
        <el-menu default-active="1" :collapse="isver" mode="">
          <el-menu-item index="1" style="padding-left:0;">
            <i class="layui-icon x-left-span x-left-span3"></i>
            <router-link to="/index/personmanage" class="x-index-link">人员管理</router-link>
          </el-menu-item>
            <el-menu-item index="2" style="padding-left:0;">
              <i class="layui-icon x-left-span x-left-span1"></i>
              <router-link to="/index/mainpro" class="x-index-link">学习中心</router-link>
            </el-menu-item>
            <el-menu-item index="3" style="padding-left:0;">
              <i class="layui-icon x-left-span x-left-span4"></i>
              <router-link to="/index/missioncenter" class="x-index-link">任务中心</router-link>
              <!-- <span slot="title"></span> -->
            </el-menu-item>
            <el-menu-item index="4" style="padding-left:0;">
              <i class="layui-icon x-left-span x-left-span2"></i>
              <router-link to="/index/examcenter" class="x-index-link">考核中心</router-link>
            </el-menu-item>
            <el-menu-item index="5" style="padding-left:0;">
              <i class="layui-icon x-left-span x-left-span5"></i>
              <router-link to="/index/maincompany" class="x-index-link">企业中心</router-link>
            </el-menu-item>
            <el-menu-item index="6" style="padding-left:0;">
              <i class="layui-icon x-left-span x-left-span6"></i>
              <router-link to="/index/admin" class="x-index-link">账号管理</router-link>
            </el-menu-item>
            <el-menu-item index="7" style="padding-left:0;">
              <i class="layui-icon x-left-span x-left-span7"></i>
              <router-link to="/index/group" class="x-index-link">论坛管理</router-link>
            </el-menu-item>
            <el-menu-item index="9" style="padding-left:0;">
              <i class="layui-icon x-left-span x-left-span8"></i>
              <router-link to="/index/wifilist" class="x-index-link">WIFI管理</router-link>
            </el-menu-item>
            <el-menu-item index="10" style="padding-left:0;">
              <i class="layui-icon x-left-span x-left-span9"></i>
              <router-link to="/index/signup" class="x-index-link">报名管理</router-link>
            </el-menu-item>
            <el-menu-item index="11" style="padding-left:0;">
              <i class="layui-icon x-left-span x-left-span4"></i>
              <router-link to="/index/shoping" class="x-index-link">商城管理</router-link>
            </el-menu-item>

            <el-menu background-color="#bda17a" text-color="#fff" active-text-color="#ffd04b" class="el-menu-vertical-demo" unique-opened router >
                <template>
                    <el-submenu index="8">
                        <template slot="title">
                            <i class="layui-icon x-left-span x-left-span8" style="margin-left: -10px"></i>
                            <span style="padding-left: 40px">培训数据中台</span>
                        </template>
                        <el-menu-item-group>
                          <el-menu-item>
                            <router-link to="/index/datacenter1" class="x-index-link">课程数据</router-link>
                          </el-menu-item>
                          <el-menu-item>
                            <router-link to="/index/datacenter2" class="x-index-link">任务数据</router-link>
                          </el-menu-item>
                          <el-menu-item>
                            <router-link to="/index/datacenter3" class="x-index-link">考试数据</router-link>
                          </el-menu-item>
                          <el-menu-item>
                            <router-link to="/index/datacenter4" class="x-index-link">学员档案</router-link>
                          </el-menu-item>
                          <el-menu-item>
                            <router-link to="/index/wenjuan" class="x-index-link">留言反馈</router-link>
                          </el-menu-item>
                          <el-menu-item>
                            <router-link to="/index/datacenter5" class="x-index-link">日志统计</router-link>
                          </el-menu-item>
                          <!-- <el-menu-item>
                            <router-link to="/index/datacenter6" class="x-index-link">组织档案</router-link>
                          </el-menu-item> -->
                        </el-menu-item-group>
                    </el-submenu>
                </template>
            </el-menu>

        </el-menu>
      </el-aside>
      <!-- header -->
      <el-container>
        <el-header style="text-align: right; font-size: 12px" class="x-header-box">
          <div class="x-top-left" v-model="isCollapse"><span class="x-fold-icon" :label="true"></span>欢迎您进入元乐培训后台管理系统系统</div>
          <div class="x-top-center">大连元乐文化有限公司</div>
          <el-dropdown class="x-admin-user" placement="top-start" @command="handleCommand">
            <span class="el-dropdown-link">
              <span class="x-username">{{ username }}</span>
              <i class="el-icon-caret-bottom" style="margin-right: 15px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="editlogin">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </el-header>
        <!--  -->
        <el-breadcrumb separator-class="el-icon-arrow-right" class="x-bread">
          <!-- <i class="x-left-span x-left-span1"></i> -->
          <!-- <el-breadcrumb-item :to="{ path: '/Index/mainpro' }">学习中心</el-breadcrumb-item> -->
           <el-breadcrumb-item v-for="item in levelList" :key="item.path" v-if="item.meta.title" :to="item.redirect||item.path">{{item.meta.title}}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-main>
            <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      msg: '',
      activeIndex: '1',
      username:localStorage.username,
      company:localStorage.company,
      logo:localStorage.logo,
      token:'',
      user_id:'',
      levelList:null,
      isCollapse: true,
      isver:false
    }
  },
  created(){
    // let phone = localStorage.phone
    // console.log('phone =', phone)
    // let company = localStorage.company
    // console.log('company =', company)
    // let token = localStorage.token
    // console.log('token =', token)
    // let user_id = localStorage.user_id
    // console.log('user_id =', user_id)
    console.log(localStorage.username);
  },
  mounted() {
    //do something after mounting vue instance
    this.getBreadcrumb()
  },
  watch:{
    $route(to,from){
      this.getBreadcrumb()
    }
  },
  methods: {
    handleCommand(command) {
      console.log('退出登陆');
      localStorage.token = '';
      this.$router.push({name:'Login'});
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.meta.title)
      console.log(matched);
      this.levelList = matched;
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
    color: #fff!important;
}.el-menu{
  background-color: rgb(24, 43, 92);
  color: #fff;
}  .el-submenu__title{
    background-color: green;
    color: #fff;
  }.el-menu-item:hover{
    background:rgba(100,156,238,.2);
  }.el-aside ul li{
    width: 200px;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    text-align: -webkit-left;
    padding-left: 10px;
  }.index{
    height: 100%;
  }.el-container{
    height: 100%;
  }.el-aside{
    height: 100%;
  }.el-icon-arrow-down:before {
    content: "";
}.el-menu-item{
  color:#fff;
}.el-menu-item:focus, .el-menu-item:hover,.el-menu-item.is-active{
  background-color:#A38965;
  color: #fff;
}.el-menu-item{
  color: rgba(255,255,255,.7);
}.x-left-span {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
    position: absolute;
    top: 20px;
    left: 40px;
}.x-left-span1 {
    background: url(../images/leftspan11.png)no-repeat;
    background-size: contain;
}.x-left-span2{
	background:url(../images/leftspan22.png)no-repeat;
	background-size: contain;
}.x-left-span3{
	background:url(../images/leftspan33.png)no-repeat;
	background-size: contain;
}.x-left-span4{
	background:url(../images/leftspan44.png)no-repeat;
	background-size: contain;
}.x-left-span5{
	background:url(../images/leftspan66.png)no-repeat;
	background-size: contain;
}.x-left-span6{
	background:url(../images/leftspan77.png)no-repeat;
	background-size: contain;
}.x-left-span7{
	background:url(../images/leftspan55.png)no-repeat;
	background-size: contain;
}.x-left-span8{
	background:url(../images/leftspan88.png)no-repeat;
	background-size: contain;
}.x-left-span9{
	background:url(../images/leftspan99.png)no-repeat;
	background-size: contain;
}
.el-menu-item.is-active .x-left-span1{
    background: url(../images/leftspan1.png)no-repeat;
    background-size: contain;
}.el-menu-item.is-active .x-left-span2 {
    background: url(../images/leftspan2.png)no-repeat;
    background-size: contain;
}.el-menu-item.is-active .x-left-span3 {
    background: url(../images/leftspan3.png)no-repeat;
    background-size: contain;
}.el-menu-item.is-active .x-left-span4 {
    background: url(../images/leftspan4.png)no-repeat;
    background-size: contain;
}.el-menu-item.is-active .x-left-span5 {
    background: url(../images/leftspan6.png)no-repeat;
    background-size: contain;
}.el-menu-item.is-active .x-left-span6 {
    background: url(../images/leftspan7.png)no-repeat;
    background-size: contain;
}.el-menu-item.is-active .x-left-span7 {
    background: url(../images/leftspan5.png)no-repeat;
    background-size: contain;
}.el-menu-item.is-active .x-left-span8 {
    background: url(../images/leftspan8.png)no-repeat;
    background-size: contain;
}.el-menu-item.is-active .x-left-span9 {
    background: url(../images/leftspan9.png)no-repeat;
    background-size: contain;
}.x-index-logo{
  margin: 10px 20px;
  color: #fff;
  background: url(../images/logo.png)no-repeat center;
  background-size: cover;
  width: 150px;
  height: 110px;
}
.x-header-box{
  background-color: #fff;
  color: #A6A6A6;
  line-height: 60px;
  text-align: center!important;
  font-size: 14px!important;
}.x-username{
  color: #999;
  margin-right: 10px;
}.x-top-left {
  position: absolute;
  color: #A6A6A6;
  top: 0;
  left: 240px;
}.x-top-center {
  color: #3F3F3F;
}.x-admin-user{
  position: absolute!important;
  top: 22px;
  right: 40px;
  line-height: initial;
}.x-bread{
  height: 40px;
  line-height: 40px;
  padding: 0 80px 0 40px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}a{
  text-decoration: none;
}.el-menu{
  background-color: #BDA17A!important;
  color: #fff;
  width: 200px;
}.x-index-link{
  display: inline-block;
  width: 100%;
  padding-left: 70px;
  box-sizing: border-box;
}.el-menu-item.is-active .x-index-link{
  color: #F9BF70!important;
}
</style>
<style media="screen">
.x-fold-icon{
  background: url(../images/fold.png)no-repeat;
  background-size: contain;
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 15px;
  cursor: pointer;
}.x-fold-icon:hover{
  opacity: .5;
}.el-menu--inline .x-index-link{
  padding-left: 0;
}.el-submenu__title i{
  color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue